export interface ICreateLiftReportInput {
  goalId: string;
  mainGoal: boolean;
}

class CreateLiftReportInput {
  public readonly goalId: string;
  public readonly mainGoal: boolean;

  constructor({ goalId, mainGoal }: { goalId: string; mainGoal: boolean }) {
    this.goalId = goalId;
    this.mainGoal = mainGoal;
  }

  public toJSON = () => ({
    goalId: this.goalId,
    mainGoal: this.mainGoal,
  });

  public static fromJSON = (json: ICreateLiftReportInput): CreateLiftReportInput => {
    const { goalId, mainGoal } = Object.assign({}, json);

    if (typeof goalId !== 'string') throw new Error('.goalId must be a string');
    if (typeof mainGoal !== 'boolean') throw new Error('.mainGoal must be a boolean');

    return new CreateLiftReportInput({
      goalId,
      mainGoal,
    });
  };
}

export default CreateLiftReportInput;
